import ErrorPic from '@/ui/assets/error-icon.svg';
import { Button, Heading, Icon, Text } from '@/ui/components';
import { IconProps, SolidIconName } from '@/ui/components/Icon/Icon.types';
import cn from 'classnames';
import Image from 'next/image';

import { useTranslations } from 'next-intl';
import s from './SomethingWrong.module.css';

type SomethingWrongProps = {
  title?: string;
  description?: string;
  primaryButtonLabel?: string;
  primaryButtonIcon?: IconProps['name'];
  secondaryButtonLabel?: string;
  onPrimaryButtonClick: () => void;
  onSecondaryButtonClick?: () => void;
};

const SomethingWrong = ({
  title,
  description,
  primaryButtonLabel,
  primaryButtonIcon = 'Restart',
  secondaryButtonLabel,
  onPrimaryButtonClick,
  onSecondaryButtonClick,
}: SomethingWrongProps) => {
  const defaultTranslations = useTranslations('something-wrong');

  return (
    <article className={cn(s.wrapper)}>
      <Image src={ErrorPic} className={s.picture} alt="Error Image" />
      <div>
        <Heading spacing="tiny" centerText weight="medium">
          {title ?? defaultTranslations('title')}
        </Heading>
        <Text centerText>{description ?? defaultTranslations('description')}</Text>
      </div>
      <footer className={s.footer}>
        <Button
          isFullWidth
          spacing="small"
          onClick={onPrimaryButtonClick}
          icon={<Icon variant="solid" name={primaryButtonIcon as SolidIconName} color="white" />}
        >
          {primaryButtonLabel ?? defaultTranslations('primary-button-label')}
        </Button>
        {onSecondaryButtonClick && (
          <Button
            isFullWidth
            variant="link"
            icon={<Icon variant="solid" name="ChevronLeft" color="iris-500" />}
            onClick={onSecondaryButtonClick}
          >
            {secondaryButtonLabel ?? defaultTranslations('secondary-button-label')}
          </Button>
        )}
      </footer>
    </article>
  );
};

export default SomethingWrong;
